'use strict';
const cleanDOMId = require('./clean-dom-id');
module.exports = function linkKey(linkObj) {
	return cleanDOMId('link_' + linkObj.ideaIdFrom + '_' + linkObj.ideaIdTo);
};
